module.exports = __webpack_public_path__ + "static/media/c12_6.37cae665.png";